<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<form class="modal-content" #f="ngForm" (ngSubmit)="saveConfig(f)">
  <div class="modal-header">
    <h5 class="modal-title" [xdaTranslate]="'SDE_WORKFLOW_SETTINGS'"></h5>
  </div>
  <div class="modal-body" tabindex="-1">
    @if (isAdvancedPlan) {
      <div class="settings-toolbar">
        <h4
          class="h4 align-self-center flex-grow-1 setting-type-label m-0"
          [xdaTranslate]="activeTab"></h4>
        <div class="form-group d-flex justify-content-center">
          <div
            class="xrx-seg-control"
            role="tablist"
            aria-label="Select Workflows or Features">
            <button
              type="button"
              class="xrx-btn xgl-workflow_central btn-secondary"
              [ngClass]="{ checked: selectedConfig == 'workflows' }"
              [ngbTooltip]="'SDE_WORKFLOWS' | xdaTranslate"
              triggers="hover"
              (click)="
                selectConfig('workflows', f); activeTab = 'SDE_WORKFLOWS'
              ">
              <span class="btn-label" [xdaTranslate]="'SDE_WORKFLOWS'"></span>
            </button>
            <button
              type="button"
              class="xrx-btn xgl-checklist_rtl btn-secondary"
              [ngClass]="{ checked: selectedConfig == 'features' }"
              [ngbTooltip]="'SDE_FEATURES' | xdaTranslate"
              (click)="selectConfig('features', f); activeTab = 'SDE_FEATURES'">
              <span class="btn-label" [xdaTranslate]="'SDE_FEATURES'"></span>
            </button>
            <button
              type="button"
              class="xrx-btn xgl-shield_gears btn-secondary"
              [ngClass]="{ checked: selectedConfig == 'security' }"
              [ngbTooltip]="'SDE_SECURITY' | xdaTranslate"
              (click)="selectConfig('security', f); activeTab = 'SDE_SECURITY'">
              <span class="btn-label" [xdaTranslate]="'SDE_SECURITY'"></span>
            </button>
          </div>
        </div>
      </div>
    }
    @if (selectedConfig == 'workflows') {
      <div>
        @if (isAdvancedPlan) {
          <div class="config-autoworkflow">
            <section class="autoworkflow">
              <xrx-toggle-switch
                [label]="'SDE_ENABLE_AUTOMATED_WORKFLOWS'"
                [glyph]="'xgl-auto'"
                [isMfd]="false"
                [switchOn]="config.enableAutoWorkflows"
                (toggle)="
                  onToggleAutoWorkflows($event, 'enableAutoWorkflows', '')
                "></xrx-toggle-switch>
            </section>
          </div>
        }
        <div
          class="config-container workflows-container"
          [ngClass]="{ 'workflows-full': isAdvancedPlan }">
          <div
            class="config-label d-flex justify-content-between align-items-center">
            <span class="label-left" [xdaTranslate]="'SDE_WORKFLOWS'"></span>
            <span class="label-right" [xdaTranslate]="'SDE_SHOW'"></span>
          </div>
          <div class="config config-workflows">
            @for (
              workflow of preconfiguredWorkflows;
              track workflow;
              let first = $first
            ) {
              <section [ngClass]="{ first: first }">
                <xrx-toggle-switch
                  [label]="workflow.name"
                  [image]="workflow.icon.image"
                  [isMfd]="false"
                  [switchOn]="config.workflows[workflow.id || '']"
                  (toggle)="
                    onToggle($event, workflow.id || '', 'workflows')
                  "></xrx-toggle-switch>
              </section>
            }
            @if (isAdvancedPlan) {
              <div class="combined-workflows">
                @for (workflow of combinedWorkflows; track workflow) {
                  <section>
                    <xrx-toggle-switch
                      [label]="workflow.name"
                      [image]="workflow.icon.image"
                      [isMfd]="false"
                      [switchOn]="config.workflows[workflow.id || '']"
                      (toggle)="
                        onToggle($event, workflow.id || '', 'workflows')
                      "></xrx-toggle-switch>
                  </section>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
    @if (selectedConfig == 'features') {
      <div class="features-container">
        <div class="config-container features-container">
          <div
            class="config-label d-flex justify-content-between align-items-center">
            <span class="label-left" [xdaTranslate]="'SDE_FEATURE'"></span>
            <span class="label-right" [xdaTranslate]="'SDE_SHOW'"></span>
          </div>
          <div class="config config-features">
            <section class="email">
              <xrx-toggle-switch
                [label]="'SDE_ENCRYPT_TRACK_EMAIL'"
                [isMfd]="false"
                [switchOn]="config.email"
                (toggle)="onToggle($event, 'email', '')"></xrx-toggle-switch>
            </section>
          </div>
        </div>
        <div class="config-container repo-container">
          <div
            class="config-label d-flex justify-content-between align-items-center">
            <span
              class="label-left"
              [xdaTranslate]="'SDE_CLOUD_REPOSITORIES'"></span>
            <span class="label-right" [xdaTranslate]="'SDE_SHOW'"></span>
          </div>
          <div class="config config-repos">
            @for (
              repo of cloudRepos;
              track repo;
              let first = $first;
              let last = $last
            ) {
              <section [ngClass]="{ first: first, last: last }">
                <xrx-toggle-switch
                  [label]="repo.key"
                  [isMfd]="false"
                  [switchOn]="config.repos[repo.value + repo.region]"
                  (toggle)="
                    onToggle($event, repo.value + repo.region, 'repos')
                  "></xrx-toggle-switch>
              </section>
            }
          </div>
        </div>
      </div>
    }
    @if (selectedConfig == 'security') {
      <div>
        @if (isAdvancedPlan) {
          <div>
            <div
              class="tenant-container"
              [ngClass]="{ disabled: !canEnableTenantId() }"
              [ngbTooltip]="tenantToolTip"
              [disableTooltip]="canEnableTenantId()">
              <section class="tenant">
                <xrx-toggle-switch
                  [label]="'SDE_MICROSOFT_TENANT_RESTRICTIONS'"
                  [isMfd]="false"
                  [switchOn]="config.enableTenant"
                  (toggle)="onToggle($event, 'enableTenant', '')"
                  [disabled]="!canEnableTenantId()"></xrx-toggle-switch>
              </section>
            </div>
            @if (config.enableTenant) {
              <div class="tenant-content">
                <label
                  class="info"
                  [xdaTranslate]="'SDE_DIRECTORY_TENANT_ID'"></label>
                <xrx-input
                  type="text"
                  id="tenantId"
                  name="tenantId"
                  [(ngModel)]="tenantId"
                  [placeholder]="tenantInput.format"
                  [disabled]="!canEnableTenantId()"
                  [required]="true"
                  [maxlength]="tenantInput.maxlength"
                  [maxlengtherror]="tenantInput.maxlengthError"
                  [pattern]="tenantInput.validation"
                  [patternerror]="tenantInput.validationError"
                  [ngbTooltip]="tenantToolTip"
                  [disableTooltip]="canEnableTenantId()">
                </xrx-input>
              </div>
            }
            <section class="domain-restriction">
              <xrx-toggle-switch
                [label]="'SDE_LIMIT_SPECIFIC_EMAIL'"
                [isMfd]="false"
                [switchOn]="config.enableDomainRestrictions"
                (toggle)="
                  onToggle($event, 'enableDomainRestrictions', '')
                "></xrx-toggle-switch>
            </section>
            @if (config.enableDomainRestrictions) {
              <div class="domain-container">
                <div class="info mb-2">
                  <span [xdaTranslate]="'SDE_LIMIT_WORKFLOW_EMAIL'"></span>
                  <span>&nbsp;</span>
                  <span
                    [xdaTranslate]="'SDE_ENTER_UP_FMTSTR1'"
                    [formatValues]="[maxDomains.toString()]"></span>
                </div>
                <div class="d-flex">
                  <xrx-input
                    type="text"
                    id="enterDomain"
                    name="enterDomain"
                    autocomplete="enterDomain"
                    [(ngModel)]="enterDomain"
                    placeholder="SDE_ENTER_DOMAIN_URL"
                    [required]="false"
                    [isMfd]="false"
                    class="w-100"
                    classes="textField medium"
                    error="{{ errorDomain }}">
                  </xrx-input>
                  <button
                    type="button"
                    class="xrx-btn btn-secondary add-btn xgl-plus keep-border"
                    (click)="addDomain()"
                    [disabled]="
                      enterDomain.length === 0 ||
                      config.allowedDomains.length >= maxDomains
                    ">
                    <span [xdaTranslate]="'SDE_ADD'"></span>
                  </button>
                </div>
                <!-- Domain List -->
                @if (config.allowedDomains.length) {
                  <div class="domain-list-container">
                    <ul
                      class="list-wrapper list-group"
                      [ngClass]="{ 'mb-0': config.allowedDomains.length < 1 }">
                      @for (
                        domain of config.allowedDomains;
                        track domain;
                        let i = $index;
                        let first = $first;
                        let last = $last
                      ) {
                        <li
                          role="option"
                          class="item list-group-item list-group-item-action d-flex align-items-center justify-content-between"
                          [ngClass]="{ first: first, last: last }">
                          <span class="name">{{ domain }}</span>
                          <div class="icons d-flex align-items-center">
                            <span class="edit" (click)="editDomain(i)"></span>
                            <span
                              class="delete"
                              (click)="removeDomain(i)"></span>
                          </div>
                        </li>
                      }
                    </ul>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
  <div class="modal-footer">
    <div class="cb">
      <button
        type="button"
        class="xrx-btn btn-secondary"
        data-dismiss="modal"
        (click)="activeModal.dismiss()">
        <span class="btn-label" [xdaTranslate]="'SDE_CANCEL'"></span>
      </button>
    </div>
    <div class="cb">
      <button
        type="submit"
        class="xrx-btn btn-primary"
        [ngClass]="{ disabled: !allowSave }">
        <span class="btn-label" [xdaTranslate]="'SDE_OK'"></span>
      </button>
    </div>
  </div>
</form>
